var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"unit-link",attrs:{"to":{ name: _vm.unitSideSheetUrl, params: { id: _vm.unitNumberId } }}},[_c(_setup.UnitCard,{staticClass:"unit-card",attrs:{"id":_vm.unitNumberId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }